import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Grid } from "@mui/system";
import { IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AnomaliesMissingData from "./AnomaliesTabs/AnomaliesMissingData/AnomaliesMissingData";
import AnomaliesFtd from "./AnomaliesTabs/AnomaliesFtd/AnomaliesFtd";
import AnomaliesBrands from "./AnomaliesTabs/AnomaliesBrands/AnomaliesBrands";
import AnomaliesIncome from "./AnomaliesTabs/AnomaliesIncome/AnomaliesIncome";
import AnomaliesEarnings from "./AnomaliesTabs/AnomaliesEarnings/AnomaliesEarnings";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AnomaliesTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2} alignItems="center" p={2}>
          <Grid size={6}>
            <Box display={"flex"} alignItems={"center"}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  background: "#F5F5F5",
                  borderRadius: "8px",
                  padding: "4px",
                  minHeight: "30px",
                  "& .MuiTab-root": {
                    color: "#00000061",
                    padding: "5px 16px",
                    minHeight: "30px",
                    "&.Mui-selected": {
                      color: "#000000DE",
                      background: "#ffffff",
                      borderRadius: "4px",
                    },
                  },

                  /* Active line color */
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#9C27B0",
                    height: "0px", // optional
                    borderRadius: "10px", // optional
                  },
                }}
              >
                <Tab label="MISSING DATA" {...a11yProps(0)} />
                <Tab label="FTD" {...a11yProps(1)} />
                <Tab label="BRANDS" {...a11yProps(2)} />
                <Tab label="INCOME" {...a11yProps(3)} />
                <Tab label="Earnings" {...a11yProps(4)} />
              </Tabs>
            </Box>
          </Grid>
          <Grid size={6}>
            <Box display={"flex"} justifyContent={"flex-end"}>
              <IconButton aria-label="fingerprint" color="secondary">
                <RefreshIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <CustomTabPanel value={value} index={0}>
          <AnomaliesMissingData />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <AnomaliesFtd />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <AnomaliesBrands />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <AnomaliesIncome />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <AnomaliesEarnings />
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default AnomaliesTabs;
